import React, { useMemo } from "react";

export function PqrForm() {
  const FORM_SUBMIT_EMAIL = "contactos@brightonenglishcenter.edu.co";
  const THANK_YOU_URL = "https://brightonenglishcenter.edu.co/gracias";

  const solicitudes = [
    "Petición",
    "Queja",
    "Reclamo",
    "Sugerencia",
    "Felicitación",
  ];

  const consecutivo = useMemo(() => Date.now(), []);

  const fecha = useMemo(() => {
    const date = new Date();
    return `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()}`;
  }, []);

  return (
    <section className=" bg-white rounded-lg overflow-hidden shadow-custom-first p-4 sm:p-6 lg:p-8 outline outline-1 outline-gray-200 m-5 lg:m-14">
      {/* Encabezado */}
      <div className="border-b border-gray-200 pb-5 mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-primario">
          Formulario PQRSF
        </h2>

        <p className="text-gray-600 mt-2 text-sm md:text-base">
          Registra tu petición, queja, reclamo, sugerencia o felicitación.
          Nuestro equipo dará respuesta en los tiempos establecidos.
        </p>
      </div>

      <form
        action={`https://formsubmit.co/${FORM_SUBMIT_EMAIL}`}
        method="POST"
        encType="multipart/form-data"
        className="space-y-4"
      >
        {/* CONFIG FORM SUBMIT */}
        <input
          type="hidden"
          name="_subject"
          value="Nueva PQRSF - Brighton Centro de Inglés"
        />

        <input type="hidden" name="_next" value={THANK_YOU_URL} />
        <input type="hidden" name="_template" value="table" />
        <input type="text" name="_honey" style={{ display: "none" }} />

        <input type="hidden" name="fecha" value={fecha} />
        <input type="hidden" name="consecutivo" value={consecutivo} />

        {/* FECHA Y CONSECUTIVO */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="block text-xs font-semibold text-gray-500 uppercase">
              Fecha
            </span>

            <p className="font-bold text-primario">{fecha}</p>
          </div>

          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="block text-xs font-semibold text-gray-500 uppercase">
              Consecutivo
            </span>

            <p className="font-bold text-primario">{consecutivo}</p>
          </div>
        </div>

        {/* DATOS PERSONALES */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-secundario">
            Información del solicitante
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div>
              <label htmlFor="nombre" className="block font-semibold mb-2">
                Nombre completo *
              </label>

              <input
                type="text"
                name="nombre"
                required
                placeholder="Juan Pérez"
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
            </div>

            <div>
              <label htmlFor="tipoDocumento" className="block font-semibold mb-2">
                Tipo de documento *
              </label>

              <select
                name="tipoDocumento"
                required
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              >
                <option value="">Seleccione</option>
                <option>Cédula de Ciudadanía</option>
                <option>Tarjeta de Identidad</option>
                <option>Cédula de Extranjería</option>
                <option>Pasaporte</option>
              </select>
            </div>

            <div>
              <label htmlFor="documento" className="block font-semibold mb-2">
                Número de documento *
              </label>

              <input
                type="number"
                name="documento"
                required
                placeholder="123456789"
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
                min="1"
              />
            </div>

            <div>
              <label htmlFor="telefono" className="block font-semibold mb-2">
                Teléfono *
              </label>
              <input
                type="tel"
                name="telefono"
                required
                placeholder="+57 300 123 4567"
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />

            </div>

            <div className="lg:col-span-2">
              <label htmlFor="email" className="block font-semibold mb-2">
                Correo electrónico *
              </label>

              <input
                type="email"
                name="email"
                required
                placeholder="correo@ejemplo.com"
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              />
            </div>
          </div>
        </div>

        {/* INFORMACIÓN PQRSF */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-secundario">
            Información de la solicitud
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div>
              <label className="block font-semibold mb-2">
                Dirigido a *
              </label>

              <input
                type="text"
                name="dirigidoA"
                required
                placeholder="Área Académica, Dirección, Coordinación..."
                className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
            </div>

            <div>
              <label htmlFor="canalRecepcion" className="block font-semibold mb-2">
                Canal de recepción *
              </label>

              <input
                type="text"
                name="canalRecepcion"
                value="Página Web"
                readOnly
                className="w-full p-3 rounded-lg border border-gray-300 bg-gray-100"
              />
            </div>
          </div>

          {/* TIPO DE SOLICITUD */}
          <div>
            <label htmlFor="tipoSolicitud" className="block font-semibold mb-3">
              Tipo de solicitud *
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3">
              {solicitudes.map((item) => (
                <label
                  key={item}
                  className="flex items-center gap-2 p-3 rounded-lg border border-gray-300 cursor-pointer hover:border-yellow-1"
                >
                  <input
                    type="radio"
                    name="tipoSolicitud"
                    value={item}
                    required
                    className="accent-yellow-500"
                  />

                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* DESCRIPCIÓN */}
          <div>
            <label htmlFor="descripcion" className="block font-semibold mb-2">
              Descripción del reporte *
            </label>

            <textarea
              name="descripcion"
              required
              rows={8}
              placeholder="Describe detalladamente tu solicitud..."
              className="w-full p-4 rounded-lg border border-gray-300 resize-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
            />
          </div>

          {/* ADJUNTO */}
          <div>
            <label htmlFor="adjunto" className="block font-semibold mb-2">
              Adjuntar evidencia (Opcional)
            </label>

            <input
              type="file"
              name="adjunto"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              className="w-full p-3 border border-gray-300 rounded-lg"
            />
          </div>

          {/* RESPUESTA */}
          <div>
            <label htmlFor="medioRespuesta" className="block font-semibold mb-3">
              Medio preferido de respuesta
            </label>

            <div className="flex flex-col sm:flex-row gap-4">
              <label htmlFor="medioRespuesta" className="flex items-center gap-2">
                <input
                  type="radio"
                  name="medioRespuesta"
                  value="Correo electrónico"
                  defaultChecked
                />
                Correo electrónico
              </label>

              <label htmlFor="medioRespuesta" className="flex items-center gap-2">
                <input
                  type="radio"
                  name="medioRespuesta"
                  value="Teléfono"
                />
                WhatsApp / Teléfono
              </label>
            </div>
          </div>
        </div>

        {/* DATOS PERSONALES */}
        <div className="bg-gray-50 rounded-lg p-4">
          <label htmlFor="aceptaDatos" className="flex items-start gap-3">
            <input
              type="checkbox"
              name="aceptaDatos"
              required
              className="mt-1 accent-yellow-500"
            />

            <span className="text-sm">
              He leído y acepto la política de tratamiento de datos
              personales de Brighton Centro de Inglés. *

              <a
                href="/politica-tratamiento-datos"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secundario font-bold ml-1 hover:underline"
              >
                Consultar política
              </a>
            </span>
          </label>
        </div>

        {/* BOTÓN */}
        <div className="flex justify-center">
          <button
            type="submit"
            className="bg-yellow-1 text-primario font-bold px-8 py-4 rounded-lg rounded-tl-none hover:bg-yellow-500 transition-all duration-300 shadow-custom-first"
          >
            Enviar PQRSF
          </button>
        </div>
      </form>
    </section>
  );
}